export default "__VITE_ASSET__228950c8__"